import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efd6dd18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selection-car-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selected_car_placeholder = _resolveComponent("selected-car-placeholder")!
  const _component_registration = _resolveComponent("registration")!
  const _component_selected_car = _resolveComponent("selected-car")!
  const _component_selecting_car = _resolveComponent("selecting-car")!
  const _component_other_car_info = _resolveComponent("other-car-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCarsLoading)
      ? (_openBlock(), _createBlock(_component_selected_car_placeholder, { key: 0 }))
      : (_ctx.isRegistration)
        ? (_openBlock(), _createBlock(_component_registration, { key: 1 }))
        : (_ctx.getSelectedCar && !_ctx.addingNext)
          ? (_openBlock(), _createBlock(_component_selected_car, {
              key: 2,
              onSelectNextCar: _ctx.addNextCar
            }, null, 8, ["onSelectNextCar"]))
          : (_openBlock(), _createBlock(_component_selecting_car, {
              key: 3,
              onSelectionFinished: _ctx.selectionFinished,
              onNeedRegistration: _ctx.needRegistration,
              "is-adding-next": _ctx.addingNext
            }, null, 8, ["onSelectionFinished", "onNeedRegistration", "is-adding-next"])),
    _createVNode(_component_other_car_info)
  ]))
}